import {RadioItem, StyledList} from "./StyledComponents";
import {RadioFormControlLabel} from "@kaltura/ds-react-components";

type Props = {
    channels: Record<string, string>[];
    selectedChannel: string;
    onChannelSelect: (id) => void;
}

/**
 * Import Channel modal content channels list
 */
const ImportChannelList = (props: Props) => {

    const {channels, selectedChannel, onChannelSelect} = props;

    return (
        <StyledList>
            {channels.map(channel =>
                <RadioItem key={channel.id}>
                    <RadioFormControlLabel
                        name={channel.name}
                        id={channel.id.toString()}
                        onChange={() => onChannelSelect(channel.id)}
                        value={channel.id}
                        checked={selectedChannel === channel.id}
                        labelPlacement={"end"}
                        label={channel.name}
                    />
                </RadioItem>
            )}
        </StyledList>
    )
}

export default ImportChannelList
